// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"8399d84d","807":"809d0d33","935":"b9edece3"}[chunkId] + ".chunk.js";
};